/**
 * Created by slava on 15/8/17
 */

levels.FriendRequests = function () {
    cleverapps.EventEmitter.call(this);
    this.lastServerReload = 0;
    this.requestsLogs = {};
    this.notProcessed = [];
    this.processedIds = [];
    this.retainedIds = [];

    this.load();

    this.onChangeListener = function () {};

    cleverapps.abExperiments.whenGroupsUpdated(() => {
        if (!cleverapps.flags.requestsEnabled) {
            this.deleteFakeRequests();
        }

        this.initialized = true;
    });

    cleverapps.timeouts.setInterval(() => {
        if (!this.initialized) {
            return;
        }

        this.immediatelyProcess();
        this.serverReload();
        FakeRequestSender.sendIfNeed();
    }, cleverapps.parseInterval("1 minute"));

    connector.multi.requests.on("error:send", (error, type) => {
        if (type === levels.FriendRequest.TYPE_SENT_UNIT) {
            if (error === "request_already_sent") {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.FRIEND_REQUEST_NOTSENT_UNCLIMED);
                cleverapps.notification.create(Messages.get("FriendGift.not_received"));
            } else {
                cleverapps.throwAsync(`Send unit request error: ${error}`);
            }
        }
    });
};

levels.FriendRequests.prototype = Object.create(cleverapps.EventEmitter.prototype);
levels.FriendRequests.prototype.constructor = levels.FriendRequests;

levels.FriendRequests.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.FRIEND_REQUESTS);
    if (!data) {
        this.notProcessed = [];
        this.processedIds = [];
        this.retainedIds = [];
    } else {
        this.notProcessed = [];
        const availableTypes = this.listAvailableTypes();
        data.notProcessed = data.notProcessed.filter((request) => availableTypes.indexOf(request.type) !== -1);
        for (let i = 0; i < data.notProcessed.length; i++) {
            this.notProcessed.push(levels.FriendRequest.createFriendRequest(data.notProcessed[i]));
        }

        this.processedIds = data.processedIds || [];
        this.retainedIds = data.retainedIds || [];
    }

    this.requestsLogs = cleverapps.dataLoader.load(DataLoader.TYPES.FRIEND_REQUESTS_SEND_TIME) || {};
};

levels.FriendRequests.prototype.save = function () {
    const notProcessed = [];
    for (let i = 0; i < this.notProcessed.length; i++) {
        notProcessed.push(this.notProcessed[i].getData());
    }
    cleverapps.dataLoader.save(DataLoader.TYPES.FRIEND_REQUESTS, {
        notProcessed,
        processedIds: this.processedIds,
        retainedIds: this.retainedIds
    });
};

levels.FriendRequests.prototype.isNewRequest = function (id) {
    return !this.processedIds.find((processedId) => processedId === id)
        && !this.retainedIds.find((retainedId) => retainedId === id)
        && !this.notProcessed.find((request) => request.getId() === id);
};

levels.FriendRequests.prototype.lastNotProcessedId = function () {
    for (let i = this.notProcessed.length - 1; i >= 0; i--) {
        if (this.notProcessed[i].canView()) {
            return this.notProcessed[i].id;
        }
    }
    return false;
};

levels.FriendRequests.prototype.existNotProcessed = function () {
    for (let i = 0; i < this.notProcessed.length; i++) {
        if (this.notProcessed[i].canView()) {
            return true;
        }
    }
    return false;
};

levels.FriendRequests.prototype.getNotProcessedIdsByType = function (type) {
    return this.notProcessed.filter((request) => request.getData().type === type);
};

levels.FriendRequests.prototype.existRequestFrom = function (from) {
    for (let i = 0; i < this.notProcessed.length; i++) {
        if (this.notProcessed[i].canView() && this.notProcessed[i].from === from) {
            return true;
        }
    }
    return false;
};

levels.FriendRequests.prototype.existRequestTypes = function (types) {
    for (let i = 0; i < this.notProcessed.length; i++) {
        if (types.indexOf(this.notProcessed[i].type) >= 0) {
            return true;
        }
    }
    return false;
};

levels.FriendRequests.prototype.processById = function (id) {
    const request = this.notProcessed.find((request) => request.getId() === id);
    if (!request) {
        return;
    }

    this.notProcessed = this.notProcessed.filter((request) => request.getId() !== id);

    if (request.isRetained()) {
        this.retainedIds.push(id);
    }

    if (request.onServer()) {
        this.processedIds.push(id);
        this.deleteOnServerById(id);
    }

    this.save();

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.FRIEND_REQUEST_COLLECT}`);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.FRIEND_REQUEST_COLLECT}_${request.type}`);

    this.onChangeListener();
    this.trigger("load");
};

levels.FriendRequests.prototype.immediatelyProcess = function () {
    this.notProcessed.forEach((request) => {
        const requestType = levels.FriendRequest.REQUEST_TYPES[request.type];
        if (requestType.immediatelyProcess) {
            request.process();
        }
    });
};

levels.FriendRequests.prototype.addNewRequests = function (requestSource, data, fromServer) {
    const request = levels.FriendRequest.createFriendRequest(data);

    this.notProcessed.push(request);

    if (!fromServer) {
        this.save();
    }

    const group = cleverapps.user.isFirstSession() ? "new" : "old";

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.FRIEND_REQUEST_RECEIVE}_${request.type}`);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.FRIEND_REQUEST_RECEIVE}_${requestSource}`);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.FRIEND_REQUEST_RECEIVE}_${requestSource}_${group}`);
};

levels.FriendRequests.prototype.onServerLoad = function (data) {
    const newProcessedIds = [];
    let added = false;
    const availableTypes = this.listAvailableTypes();
    if (!Array.isArray(data)) {
        cleverapps.throwAsync(`FriendRequests.onServerLoad data type is - ${typeof data}`);
        data = [];
    }
    data = data.filter((request) => availableTypes.indexOf(request.type) !== -1);
    for (let i = 0; i < data.length; i++) {
        if (this.processedIds.indexOf(data[i].id) >= 0) {
            this.deleteOnServerById(data[i].id);
            newProcessedIds.push(data[i].id);
        } else if (this.isNewRequest(data[i].id)) {
            this.addNewRequests("multiplayer", data[i], true);
            added = true;
        }
    }
    this.processedIds = newProcessedIds;
    this.save();

    if (added) {
        this.immediatelyProcess();
        this.onChangeListener();
        this.trigger("load");
    }
};

levels.FriendRequests.prototype.saveRequestLogTime = function (toUserId, type) {
    if (!levels.FriendRequest.REQUEST_TYPES[type].validateTime) {
        return;
    }

    if (!this.requestsLogs[toUserId]) {
        this.requestsLogs[toUserId] = {};
    }

    this.requestsLogs[toUserId][type] = Date.now();

    cleverapps.dataLoader.save(DataLoader.TYPES.FRIEND_REQUESTS_SEND_TIME, this.requestsLogs);
};

levels.FriendRequests.prototype.requestCanNotBeSend = function (toUserId, type) {
    if (!levels.FriendRequest.REQUEST_TYPES[type].validateTime) {
        return false;
    }

    if (!this.requestsLogs[toUserId] || !this.requestsLogs[toUserId][type]) {
        return false;
    }

    return this.requestsLogs[toUserId][type] + levels.FriendRequests.SEND_INTERVAL > Date.now();
};

levels.FriendRequests.prototype.sendServerRequest = function (toUserId, type, fromUserId, callback) {
    fromUserId = fromUserId || connector.platform.getUserID();

    connector.multi.requests.send(fromUserId, toUserId, type, (success) => {
        if (success) {
            this.saveRequestLogTime(toUserId, type);
        }

        if (callback) {
            callback(success);
        }
    });
};

levels.FriendRequests.prototype.deleteOnServerById = function (id) {
    connector.multi.requests.delete(id);
};

levels.FriendRequests.prototype.serverReload = function (force) {
    const needReload = force || this.lastServerReload + levels.FriendRequests.RELOAD_INTERVAL < Date.now()
        && cleverapps.flags.requestsEnabled
        && (["merge", "merge2"].includes(cleverapps.config.type) || cleverapps.friends.listInAppIds().length > 0);

    if (needReload) {
        this.lastServerReload = Date.now();
        connector.multi.requests.get((requests) => {
            if (requests) {
                this.onServerLoad(requests);
            }
        });
    }
};

levels.FriendRequests.prototype.deleteFakeRequests = function () {
    const filtered = this.notProcessed.filter((request) => !request.fake);

    if (filtered.length !== this.notProcessed.length) {
        this.notProcessed = filtered;
        this.onChangeListener();
        this.save();
    }
};

levels.FriendRequests.prototype.listAvailableTypes = function () {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return [levels.FriendRequest.TYPE_SENT_UNIT];
    }

    let types = [
        levels.FriendRequest.TYPE_STUCK_HELP_COINS
    ];

    if (typeof match3 === "undefined") {
        types = types.concat([
            levels.FriendRequest.TYPE_SENT_COINS,
            levels.FriendRequest.TYPE_ASK_COINS,
            levels.FriendRequest.TYPE_SENT_HELP_COINS,
            levels.FriendRequest.TYPE_ASK_HELP_COINS
        ]);
    }

    if (cleverapps.lives) {
        types = types.concat([
            levels.FriendRequest.TYPE_SENT_HELP_LIVE,
            levels.FriendRequest.TYPE_ASK_HELP_LIVE,
            levels.FriendRequest.TYPE_SENT_LIVE,
            levels.FriendRequest.TYPE_ASK_LIVE
        ]);
    }

    if (cleverapps.starChest && cleverapps.starChest.isEnabled()) {
        types = types.concat(([
            levels.FriendRequest.TYPE_SENT_HELP_STAR,
            levels.FriendRequest.TYPE_ASK_HELP_STAR,
            levels.FriendRequest.TYPE_SENT_STAR,
            levels.FriendRequest.TYPE_ASK_STAR
        ]));
    }

    return types;
};

levels.FriendRequests.sendGift = function (friendId) {
    if (!friendId) {
        cleverapps.notification.create(Messages.get("FriendGift.not_play"));
        return;
    }

    if (levels.friendRequests.requestCanNotBeSend(friendId, levels.FriendRequest.TYPE_SENT_UNIT)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.FRIEND_REQUEST_NOTSENT_COOLDOWN);
        cleverapps.notification.create(Messages.get("FriendGift.wait"));
        return;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.FRIEND_REQUEST_SENT);

    levels.friendRequests.sendServerRequest(friendId, levels.FriendRequest.TYPE_SENT_UNIT, undefined, (success) => {
        if (success) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.FRIEND_REQUEST_AWAITING);
            cleverapps.notification.create(Messages.get("FriendGift.send"));
        }
    });
};

levels.FriendRequests.RELOAD_INTERVAL = cleverapps.parseInterval("5 minutes");
levels.FriendRequests.SEND_INTERVAL = cleverapps.parseInterval("1 day");

if (cleverapps.config.debugMode) {
    levels.FriendRequests.RELOAD_INTERVAL = cleverapps.parseInterval("1 minute");
    levels.FriendRequests.SEND_INTERVAL = cleverapps.parseInterval("1 minute");
}
